import axios from "axios";
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

export const STATE = ["draft", "published", "closed", "all"]
export const SHOW_SPOTS_LEFT = ['no', 'yes']
export const SHOW_PAGE_VIEW = ['no', 'yes']

export const schema = Joi.object().keys({
	title: Joi.string().allow(''),
	state: Joi.string().valid(STATE).allow(''),
	show_spots_left: Joi.string().valid(SHOW_SPOTS_LEFT).allow(''),
	show_page_view: Joi.string().valid(SHOW_PAGE_VIEW).allow(''),
  page_setting: Joi.object().allow('').allow(null),
  theme_setting: Joi.object().allow('').allow(null),
});

export default function updatePoster(posterId, posterInfo) {

  if(!posterId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing poster ID')
      })
    })
  }

  let validateResult = Joi.validate(posterInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

	let toServer = {
		...posterInfo
	}

	if(typeof(posterInfo.state) != 'undefined'){
		toServer.state = STATE.indexOf(posterInfo.state)
	}
	if(typeof(posterInfo.show_spots_left) != 'undefined'){
		toServer.show_spots_left = SHOW_SPOTS_LEFT.indexOf(posterInfo.show_spots_left)
	}
	if(typeof(posterInfo.show_page_view) != 'undefined'){
		toServer.show_page_view = SHOW_PAGE_VIEW.indexOf(posterInfo.show_page_view)
	}

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/u_poster/${posterId}/`,
      'method': 'PUT',
      'data': JSON.stringify(toServer),
      'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/poster/updatePoster.js